import React from 'react';

class Footer extends React.Component {
    render() {
        return (
            <footer className="app-footer">
                <a href="http://www.unsa.ba">UNSA</a> &copy; 2025
                <span className="float-right">Powered by <a href="http://utic.ba">UTIC</a></span>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js